import { attr, belongsTo, hasMany } from '@ember-data/model';
import DigitalAsset from './digital-asset.ts';
import type CompanyModel from './company.ts';
import type RawFileDigitalAssetModel from './raw-file-digital-asset.ts';
import type FileHistoryLogModel from './file-history-log.ts';
import { Type } from '@warp-drive/core-types/symbols';

const _FILE_STATES = {
  'FileState.UPLOADED': 1,
  'FileState.DISPATCHED': 2,
  'FileState.PROCESSING': 3,
  'FileState.INVALID': 3,
  'FileState.FAILED': 3,
  'FileState.PROCESSED_WITH_ERRORS_OR_INVALID': 4,
  'FileState.DERELICT': 4,
  'FileState.RECORD_INSERTION': 5,
  'FileState.RECORD_INSERTED': 6,
  'FileState.REFIT_PROCESSED': 7,
};

export default class FileHistoryModel extends DigitalAsset {
  /*************************
   **  Attributes         **
   *************************/
  // unique identifier associated with a batch of documents that were uploaded together
  // @attr declare batch: string; // same as operation_id?
  @attr declare recordType: 'PartnerDataTransfer';
  @attr declare operationId: string; //uuid
  @attr declare insertedCount: number;
  @attr declare sizeConfig: Record<string, unknown>;
  @attr declare totalEmployeeCount: number;

  @attr declare createdAt: string;
  @attr declare processingStartAt: string;
  @attr declare processingEndAt: string;

  @attr declare fileState: keyof typeof _FILE_STATES;
  @attr declare fileRecordJson: string; // JSON string of the file record

  @attr declare rawFileDigitalAssetFullPath: string;
  @attr declare rawFileDigitalAssetFilename: string;

  @attr declare rawFileDigitalAssetUploadedFile: string;
  @attr declare rawFileDigitalAssetErrorFile?: string;
  @attr declare rawFileDigitalAssetErrorFileName?: string;
  @attr declare rawFileDigitalAssetCorrectedFile?: string;
  @attr declare rawFileDigitalAssetCorrectedFileName?: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('company', { async: false, inverse: 'fileHistories' })
  declare company: CompanyModel;

  @belongsTo('raw-file-digital-asset', { async: false, inverse: 'fileHistory' })
  declare rawFileDigitalAsset: RawFileDigitalAssetModel; //hasOne not hasMany

  @hasMany('file-history-log', { async: false, inverse: 'fileHistory' })
  declare fileHistoryLogs: FileHistoryLogModel[];

  [Type] = 'file-history' as const;
}
